<template>
    <div class="stack mb-3">
        <div class="m-auto text-left control-width border shadow add-rounded p-4">
            <p class="text-danger text-center font-weight-bolder mb-3" v-if="error">
                {{ error }}
            </p>

            <h5 class="mb-3 kova-text font-weight-bold">
                How many years of experience do you have as a software developer with your core tech stack?
            </h5>
            <a-input
                v-model.number="core_techstack_experience"
                type="number"
                size="large"
                class="w-25"
                :min="0"
                placeholder="0"
            />

            <br />
            <h5 class="mt-4 kova-text" v-if="!isUIUXProduct">
                List out other tech stacks where you have a high-level expertise and number of projects completed
            </h5>
            <h5 class="mt-4 kova-text" v-else>
                Other tools you are skilled at
            </h5>

            <div class="row">
                <div class="col-sm-12 col-md-6 mt-3">
                    <a-select
                        mode="multiple"
                        class="w-100"
                        v-model="other_core_techstacks"
                        size="large"
                        placeholder="Please select"
                    >
                        <a-select-option v-for="stack in stacks" :key="stack">{{ stack }}</a-select-option>
                    </a-select>
                </div>
                <div class="col-sm-12 col-md-6 mt-3">
                    <a-input
                        v-model.number="other_core_techstack_project_count"
                        type="number"
                        size="large"
                        class="w-100"
                        :min="0"
                        :max="maxLinks"
                        :placeholder="
                            isUIUXProduct
                                ? `number of products ${isProduct ? 'managed' : 'designed'}`
                                : 'number of projects you have completed'
                        "
                    />
                </div>
            </div>
            <div :key="n + 'a'" v-for="n in other_core_techstack_project_count">
                <a-input
                    @change="handleChange({ [n]: $event.target.value })"
                    class="mt-3 w-75"
                    :value="other_core_techstack_projects[n - 1] || ''"
                    addonBefore="https://"
                    placeholder="add project link"
                /><br />
            </div>

            <div>
                <h5 class="mt-4 mb-3 kova-text">Areas of Specialization</h5>
                <a-select
                    class="w-100"
                    size="large"
                    placeholder="choose your areas of specializations"
                    mode="multiple"
                    style="width: 120px"
                    v-model="specializations"
                >
                    <a-select-option :key="stack" v-for="stack in specs">{{ stack }}</a-select-option>
                </a-select>
            </div>

            <h5 class="mt-4 kova-text">{{ isUIUXProduct ? 'Portfolio' : 'Github profile' }} link</h5>
            <a-input
                class="w-50"
                size="large"
                v-if="isUIUXProduct"
                @change="portfolio_links = [$event.target.value]"
                placeholder="Portfolio Link"
            />
            <a-input
                class="w-50"
                size="large"
                v-model="github_link"
                addonBefore="https://"
                v-else
                placeholder="github.com/username"
            />

            <div class="container-fluid px-0 px-md-4 mb-5 mt-5" v-if="!overview">
                <div class="row">
                    <div class="col text-left">
                        <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack">
                            Back
                        </button>
                    </div>
                    <div class="col text-right">
                        <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { allStacks } from '../../data/resources';
import specs from '../../data/specializations.json';

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            const { core_techstack, speciality, english_proficiency } = vm.$store.state.talent.talentData;

            if (!core_techstack || !speciality || !english_proficiency) vm.$router.back();
        });
    },
    mounted() {
        const {
            core_techstack_experience,
            other_core_techstacks,
            other_core_techstack_projects,
            specializations,
            other_core_techstack_project_count,
            portfolio_links,
            github_link,
        } = this.$store.state.talent.talentData;

        this.core_techstack_experience = core_techstack_experience;
        this.other_core_techstacks = other_core_techstacks || [];
        this.other_core_techstack_projects = other_core_techstack_projects || [];
        this.other_core_techstack_project_count = other_core_techstack_project_count || 0;
        this.portfolio_links = portfolio_links || [];
        this.github_link = github_link;
        this.specializations = specializations || [];
    },
    name: 'stack',
    props: {
        overview: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            core_techstack_experience: null,
            other_core_techstacks: [],
            other_core_techstack_project_count: null,
            other_core_techstack_projects: [],
            github_link: '',
            portfolio_links: [],
            specializations: [],
            error: false,
            specs,
        };
    },
    computed: {
        isUIUXProduct() {
            const { talentData } = this.$store.state.talent;
            if (!talentData.speciality) return false;
            return talentData.speciality.includes('UI') || talentData.speciality.includes('Product');
        },
        isProduct() {
            const { talentData } = this.$store.state.talent;
            if (!talentData.speciality) return false;
            return talentData.speciality.includes('Product');
        },
        stacks() {
            const { core_techstack } = this.$store.state.talent.talentData;
            const allTools = [...new Set(allStacks)];

            if (!core_techstack) return allTools;

            if (core_techstack.includes(',')) {
                const chosenStacks = (core_techstack || []).split(',').filter(key => key.length);

                return allTools.filter(key => !chosenStacks.includes(key));
            }

            return allTools.filter(key => {
                return !key.includes(core_techstack);
            });
        },
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        next() {
            const {
                core_techstack_experience,
                other_core_techstacks,
                other_core_techstack_projects,
                other_core_techstack_project_count,
                portfolio_links,
                github_link,
                isUIUXProduct,
                specializations,
            } = this;

            this.error = !core_techstack_experience
                ? 'Select the years of experience with your core tech stack'
                : !other_core_techstacks.length
                ? 'Enter other tech stacks'
                : other_core_techstack_projects.length !== other_core_techstack_project_count
                ? 'Enter the links to all the projects you did'
                : !specializations.length
                ? 'Select at least one area of specialization'
                : !github_link && !portfolio_links.length
                ? `Enter the link to your ${isUIUXProduct ? 'portfolio' : 'GitHub'}`
                : github_link && !github_link.includes('github.com/')
                ? `Enter the correct link to your GitHub`
                : '';

            if (this.error.length) return document.querySelector('.devsignup').scrollIntoView();

            const links = github_link
                ? { github_link }
                : {
                      portfolio_links,
                  };

            this.$store.commit('talent/addToTalent', {
                ...links,
                ...this.$store.state.talent.talentData,
                core_techstack_experience,
                specializations,
                other_core_techstacks,
                other_core_techstack_projects,
                other_core_techstack_project_count,
            });

            this.$router.push('experience');
        },
        handleChange(data) {
            let key = Object.keys(data);
            this.other_core_techstack_projects[Number(key) - 1] = data[key];
            this.$forceUpdate();
        },
        linksToPortfolio() {
            const { github_link, portfolio_links } = this;
            const links = github_link
                ? { github_link }
                : {
                      portfolio_links,
                  };
            this.$store.commit('talent/updateTalent', links);
        },
    },
    watch: {
        portfolio_links: 'linksToPortfolio',
        github_link: 'linksToPortfolio',
        core_techstack_experience() {
            const { core_techstack_experience } = this;
            this.$store.commit('talent/updateTalent', {
                core_techstack_experience,
            });
        },
        other_core_techstacks() {
            const { other_core_techstacks } = this;
            this.$store.commit('talent/updateTalent', {
                other_core_techstacks,
            });
        },
        other_core_techstack_projects() {
            const { other_core_techstack_projects } = this;
            this.$store.commit('talent/updateTalent', {
                other_core_techstack_projects,
            });
        },
        other_core_techstack_project_count() {
            const { other_core_techstack_project_count } = this;
            this.$store.commit('talent/updateTalent', {
                other_core_techstack_project_count,
            });
        },
        specializations() {
            const { specializations } = this;
            this.$store.commit('talent/updateTalent', {
                specializations,
            });
        },
    },
};
</script>
<style scoped>
.control-width {
    width: 600px;
}

h3.kova-text {
    font-size: 20px;
}

h5.kova-text {
    font-size: 16px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
    .control-width {
        width: 500px;
    }
}
@media (max-width: 550px) {
    .control-width {
        width: 98%;
    }
}
</style>
